import env from "@libs/util/environment";
const RU_DEFAULT_CURRENCY = "rub";
const EU_DEFAULT_CURRENCY = "usd";
const WF_RU_DEFAULT_CURRENCY = "credits";

class CurrencyHelper {
  constructor() {
    this.initCurrencyList();
    this.default_currency = this.getCurrencyById(EU_DEFAULT_CURRENCY);
  }
  initCurrencyList() {
    this.currency_list = [
      {
        id: "usd",
        territory: "eu",
        symbol: "$",
      },
      {
        id: "eur",
        territory: "eu",
        symbol: "€",
      },
    ];
    if (env.getProject() === "wf") {
      this.currency_list.push({
        id: "credits",
        territory: "ru",
        symbol: "<i class='icon icon-credits'>",
      });
    } else {
      this.currency_list.push({
        id: "rub",
        territory: "ru",
        symbol: "₽",
      });
    }
  }
  getAllCurrencies() {
    return this.currency_list;
  }
  getCurrencyById(id) {
    return this.currency_list.find(currency => currency.id.toLowerCase() === id.toLowerCase());
  }

  /**
   * only for mycom
   */
  setDefaultCurrency(id) {
    const currency = this.getCurrencyById(id);
    if (!currency) {
      return false;
    }
    this.default_currency = currency;
    return this.default_currency;
  }
  getDefaultCurrency() {
    if (env.isMailRu()) {
      return this.getCurrencyById(
        env.getProject() === "wf" ? WF_RU_DEFAULT_CURRENCY : RU_DEFAULT_CURRENCY
      );
    }
    return this.default_currency;
  }

  /**
   * return currency list for current territory
   */
  getActualCurrencyList() {
    const territory = env.getRegion();
    return this.currency_list.filter(currency => {
      return currency.territory === territory;
    });
  }
}
export default new CurrencyHelper();
